var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { attrs: { id: "notfound" } }, [
      _c("div", { staticClass: "notfound" }, [
        _c("div", { staticClass: "notfound-404" }, [_c("h1", [_vm._v(":(")])]),
        _vm._v(" "),
        _c("h2", [_vm._v("Oops... Page not found")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The page you are looking for might have been removed had its name changed or is temporarily unavailable."
          )
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "javascript:" }, on: { click: _vm.goMain } }, [
          _vm._v("main page")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08ac19c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ac19c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/EmptyPage.vue
// module id = XwLg
// module chunks = 0